/**
 * Utility functions for response display components
 */

export const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
        return new Date(dateString).toLocaleString('en-US', {
            year: 'numeric', month: 'long', day: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    } catch {
        return dateString;
    }
};

export const getTriageLevelColor = (level) => {
    const levelLower = level?.toLowerCase() || '';
    if (levelLower.includes('critical') || levelLower.includes('emergency')) 
        return 'bg-red-100 text-red-800 border-red-300';
    if (levelLower.includes('urgent') || levelLower.includes('high')) 
        return 'bg-orange-100 text-orange-800 border-orange-300';
    if (levelLower.includes('moderate') || levelLower.includes('semi-urgent')) 
        return 'bg-yellow-100 text-yellow-800 border-yellow-300';
    return 'bg-green-100 text-green-800 border-green-300';
};

export const getConfidenceColor = (level) => {
    const levelLower = level?.toLowerCase() || '';
    if (levelLower.includes('high')) return 'text-green-600';
    if (levelLower.includes('medium') || levelLower.includes('moderate')) return 'text-yellow-600';
    return 'text-orange-600';
};

export const getProbabilityColor = (probability) => {
    const p = probability?.toLowerCase() || '';
    if (p.includes('high')) return 'bg-green-100 text-green-800 border-green-300';
    if (p.includes('moderate') || p.includes('medium')) return 'bg-yellow-100 text-yellow-800 border-yellow-300';
    if (p.includes('low')) return 'bg-orange-100 text-orange-800 border-orange-300';
    return 'bg-gray-100 text-gray-800 border-gray-300';
};

export const getPriorityColor = (priority) => {
    const p = priority?.toLowerCase() || '';
    if (p.includes('stat') || p.includes('emergency')) return 'bg-red-100 text-red-700';
    if (p.includes('urgent')) return 'bg-orange-100 text-orange-700';
    return 'bg-blue-100 text-blue-700';
};

export const PRIMARY_COLOR = '#0B7BC1';
export const PRIMARY_COLOR_HOVER = '#096aa8';
export const PRIMARY_COLOR_LIGHT = '#1B8ED1';
